var _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgServersideIconChevronBlack = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "18.35 20.38 13.28 9.25",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HILFSLINIEN"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ICONS_UMGEWANDELT"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#525861",
    d: "M31.375,20.5c-0.273-0.205-0.666-0.152-0.875,0.125L25,27.958l-5.5-7.333 c-0.209-0.278-0.601-0.331-0.875-0.125c-0.276,0.207-0.332,0.599-0.125,0.875l6,8c0.118,0.157,0.304,0.25,0.5,0.25 s0.382-0.093,0.5-0.25l6-8C31.707,21.099,31.651,20.707,31.375,20.5z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "ICONS_PFADE",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chevron-2_2_",
    transform: "translate(400 3424)",
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_6600_1_",
    fill: "none",
    stroke: "#363A40",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: " M-369-3403l-6,8l-6-8"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "BESCHRIFTUNG"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgServersideIconChevronBlack, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/serverside-icon-chevron-black.663bce29.svg";
export { ForwardRef as ReactComponent };